import React, { ReactNode } from "react";

import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

const StyledBox = styled(Box)(({ theme }) => ({
  border: "0px",
  padding: "13px",
  position: "relative",
  margin: "20px 0px auto",
  "& legend": {
    padding: "0 5px",
    position: "absolute",
    top: theme.spacing(-1.5),
    left: theme.spacing(1),
  },
}));

const InputGroup: React.FC<{ children: ReactNode; label: string }> = ({ children, label }) => {
  return (
    <StyledBox component="fieldset">
      <legend>{label}</legend>
      {children}
    </StyledBox>
  );
};

export default InputGroup;
